import { evidenceItems } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

export default function EvidenceSection() {
  return (
    <section id="shilu" className="container-x py-10 md:py-14">
      <SectionHeading
        kicker="主线归档 · 前因后果与锤点"
        title="实锤集合"
        desc="每一条都标好了链：先发生了什么、锤在哪、现在定到哪一步。红标=已实锤，橙标=存疑还在跟，不会再让你在过期帖里来回翻。"
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
        {evidenceItems.map((e) => (
          <a
            key={e.title}
            href="#luntan"
            className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
          >
            <div className="relative h-44 w-full overflow-hidden bg-background-200">
              <img
                src={e.image}
                alt={`吃瓜网爆实锤集合 · ${e.tag} · ${e.title}`}
                className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]"
              />
              <span className="absolute left-3 top-3 rounded-md bg-black/45 px-2 py-1 text-xs font-semibold text-white backdrop-blur">
                {e.tag}
              </span>
              <span
                className={`absolute right-3 top-3 inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-semibold ${
                  e.statusType === "ok"
                    ? "bg-accent-500 text-background-50"
                    : "bg-secondary-300 text-background-50"
                }`}
              >
                {e.statusType === "ok" ? <i className="ri-check-line"></i> : <i className="ri-time-line"></i>}
                {e.status}
              </span>
            </div>

            <div className="flex flex-1 flex-col p-4">
              <h3 className="font-heading text-[15px] font-bold leading-snug text-foreground-950">
                {e.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-[13px] leading-relaxed text-foreground-500">{e.brief}</p>
              {/* evidence chain */}
              <div className="mt-3 flex flex-wrap items-center gap-1.5">
                {e.chain.map((c, i) => (
                  <span key={c} className="inline-flex items-center gap-1">
                    <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-700 whitespace-nowrap">
                      {c}
                    </span>
                    {i < e.chain.length - 1 && (
                      <i className="ri-arrow-right-line text-xs text-foreground-300"></i>
                    )}
                  </span>
                ))}
              </div>
              <div className="mt-3 flex items-center justify-between border-t border-background-200/70 pt-3 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1 text-primary-600">
                  <i className="ri-fire-fill"></i>
                  {e.heat}
                </span>
                <span className="inline-flex items-center gap-1 group-hover:text-primary-600">
                  展开时间轴<i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}